import React, { forwardRef } from 'react'
import { SwipeableDrawer, IconButton, Grid } from '@material-ui/core'

import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

import { colors } from 'theme'

const Mobile = ({ children, open, handleOpen, handleClose }) => {
  return (
    <React.Fragment>
      <Grid container justify="flex-start">
        <IconButton onClick={handleOpen}>
          <MenuIcon
            css={{
              color: colors.navyblue,
            }}
          />
        </IconButton>
      </Grid>
      <SwipeableDrawer
        variant="temporary"
        anchor="left"
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <Grid container justify="flex-end">
          <Grid item>
            <IconButton onClick={handleClose}>
              <ChevronLeftIcon
                css={{
                  color: colors.navyblue,
                }}
              />
            </IconButton>
          </Grid>
        </Grid>
        {children}
      </SwipeableDrawer>
    </React.Fragment>
  )
}

export default forwardRef(Mobile)
